import * as handler from './handler';
import { PATH_COPY_TRANDING, PATH_SUBSCRIPTIONS, PATH_STRATEGIES_SUB_PLANS } from './path';

const getHostedAccountList = () =>
  handler.get(`${PATH_COPY_TRANDING}users`).then((res) => {
    return res;
  });

const hostAccountForCopyTrading = (portfolioId, userId) =>
  handler.post(`${PATH_COPY_TRANDING + userId}/request-host-account/${portfolioId}`).then((res) => {
    return res;
  });

const getPortfolioDetails = (portfolioId, userId) =>
  handler.get(`${PATH_COPY_TRANDING + userId}/${portfolioId}`).then((res) => {
    return res;
  });

const getHistoricalBacktesting = (portfolioId, userId) =>
  handler.get(`${PATH_COPY_TRANDING + userId}/chart-data/${portfolioId}/historical-backtesting`).then((res) => {
    return res;
  });

const getDrawdown = (portfolioId, userId) =>
  handler.get(`${PATH_COPY_TRANDING + userId}/chart-data/${portfolioId}/drawdown`).then((res) => {
    return res;
  });

const getMonthlyReturn = (portfolioId, monthYear, userId) =>
  handler.get(`${PATH_COPY_TRANDING + userId}/chart-data/${portfolioId}/monthly-return/${monthYear}`).then((res) => {
    return res;
  });

const getAnnualReturn = (portfolioId, userId) =>
  handler.get(`${PATH_COPY_TRANDING + userId}/chart-data/${portfolioId}/annual`).then((res) => {
    return res;
  });

const getTrading = (portfolioId, userId) =>
  handler.get(`${PATH_COPY_TRANDING + userId}/chart-data/${portfolioId}/radar`).then((res) => {
    return res;
  });

const getUserGain = (portfolioId, userId) =>
  handler.get(`${PATH_COPY_TRANDING + userId}/chart-data/${portfolioId}/portfolio-gain`).then((res) => {
    return res;
  });

const getSubscriptionDetails = (portfolioId, userId) =>
  handler.get(`${PATH_SUBSCRIPTIONS + userId}/copy-trading/${portfolioId}`).then((res) => {
    return res;
  });

const getPortfolioSubscriptions = (portfolioId) =>
  handler.get(`${PATH_STRATEGIES_SUB_PLANS}/copy-trading/${portfolioId}`).then((res) => {
    return res;
  });

const subscribeToPortfolio = (payload, userId) =>
  handler.post(`${PATH_SUBSCRIPTIONS + userId}/copy-trading`, payload).then((res) => {
    return res;
  });

const startTrading = (portfolioId, payload, userId) =>
  handler.post(`${PATH_COPY_TRANDING + userId}/${portfolioId}`, payload).then((res) => {
    return res;
  });

export default {
  getHostedAccountList,
  hostAccountForCopyTrading,
  getPortfolioDetails,
  getHistoricalBacktesting,
  getDrawdown,
  getMonthlyReturn,
  getAnnualReturn,
  getTrading,
  getUserGain,
  getSubscriptionDetails,
  getPortfolioSubscriptions,
  subscribeToPortfolio,
  startTrading,
};
